export const applyVehiculeFilters = (annonce, filters) => {
  const {
    type = [],
    carburant = [],
    chevauxMin,
    chevauxMax,
    kilometrageMin,
    kilometrageMax,
    anneeModeleMin,
    anneeModeleMax,
    prixMin,
    prixMax,
  } = filters;

  return (
    (type.length === 0 || type.includes(annonce.typeVehicule)) &&
    (carburant.length === 0 || carburant.includes(annonce.carburant)) &&
    (!chevauxMin || annonce.chevaux >= parseFloat(chevauxMin)) &&
    (!chevauxMax || annonce.chevaux <= parseFloat(chevauxMax)) &&
    (!kilometrageMin || annonce.kilometrage >= parseFloat(kilometrageMin)) &&
    (!kilometrageMax || annonce.kilometrage <= parseFloat(kilometrageMax)) &&
    (!anneeModeleMin || annonce.annee >= parseInt(anneeModeleMin)) &&
    (!anneeModeleMax || annonce.annee <= parseInt(anneeModeleMax)) &&
    (!prixMin || annonce.prix >= parseFloat(prixMin)) &&
    (!prixMax || annonce.prix <= parseFloat(prixMax))
  );
};
